<template>
<div class="egl-dialog-elm">
  <el-dialog :title="dialogTitle" :visible="isShow" class="egl-dialog offset-dialog" :modal="false" :before-close="closeDialog" :close-on-click-modal="false">
    <el-form>
      <div class="module-item">
        <div class="module-item-tit">{{ $locale("global.basicInfo") }}</div>
        <el-row :gutter="25">
          <el-col :span="4">
            <el-form-item :label="$locale('global.cinemaName')">
              <el-input v-model="basicObj.cinemaName" class="no-border"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$locale('accountPayable.customerName')">
              <el-input v-model="basicObj.clientName" class="no-border" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$locale('global.titleOfWork')">
              <el-input v-model="basicObj.filmName" class="no-border" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$locale('accountPayable.targetPeriod')">
              <el-input v-model="basicObj.time" class="no-border" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$locale('accountPayable.th.accountPayableBalance')">
              <el-input v-model="basicObj.actualAmountResidual" class="no-border" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="module-item">
        <div class="module-item-tit">{{ $locale("accountPayable.accountReceivableOffset") }}</div>
        <Table1 v-if="isShow" @setOffset="getOffsetList" ref="table1" :visible="isShow"></Table1>
      </div>

      <div class="module-item">
        <div class="module-item-tit">{{ $locale("accountPayable.otherOperatingIncomeOffset") }}</div>
        <Table2 v-if="isShow" @setOffset="getOffsetList" ref="table2"></Table2>
      </div>

      <div class="module-item">
        <div class="module-item-tit">{{ $locale("accountPayable.otherPurchaseOffset") }}</div>
        <Table3 v-if="isShow" @setOffset="getOffsetList" ref="table3"></Table3>
      </div>

      <div class="module-item">
        <el-row>
          <el-col :span="8" :offset="8">{{ $locale("accountPayable.otherOffsetTotal") }}</el-col>
          <el-col :span="8">{{ offset.payAmount.toLocaleString() }}</el-col>
        </el-row>
      </div>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button class="egl-btn-white" @click="closeDialog">{{ $locale("global.cancel") }}</el-button>
      <el-button class="egl-btn-yellow" @click="save_fn">{{ $locale("global.save") }}</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import Table1 from "./OffsetTable1.vue";
import Table2 from "./OffsetTable2.vue";
import Table3 from "./OffsetTable3.vue";

export default {
  name: "AccountPayablePaymentOtherOffset",
  data() {
    return {
      dialogTitle: this.$locale("accountPayable.otherOffset") + this.$locale("global.registration"),
      offset: {
        payAmount: 0,
        invoice: [],
        revenue: [],
        other: [],
      },
      tableOffsetTotal: [0, 0, 0],
    };
  },
  watch: {
    isShow(_nv, _ov) {
      if (_nv && _nv !== _ov) {
        this.offset = {
          payAmount: 0,
          invoice: [],
          revenue: [],
          other: [],
        };
      }
    },
  },
  methods: {
    closeDialog() {
      this.$emit("closeFn");
    },
    save_fn() {
      this.$emit("setOffset", this.offset);
    },
    getOffsetList(keyName, list, tableOffsetTotal) {
      switch(keyName) {
      case "invoice":
        this.tableOffsetTotal[0] = parseFloat(tableOffsetTotal);
        break;

      case "revenue":
        this.tableOffsetTotal[1] = parseFloat(tableOffsetTotal);
        break;

      case "other":
        this.tableOffsetTotal[2] = parseFloat(tableOffsetTotal);
        break;
      }

      this.offset[keyName] = list;
      this.offset.payAmount = this.tableOffsetTotal[0] + this.tableOffsetTotal[1] + this.tableOffsetTotal[2];
    },
  },
  props: {
    isShow: {
      type: Boolean,
      default: () => false,
    },
    basicObj: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Table1,
    Table2,
    Table3,
  },
};
</script>
